import axios, { AxiosRequestConfig } from 'axios';
import { baseUrl } from './http'

export class TokenStorage {

    static LOCAL_STORAGE_TOKEN = 'token';

   static isAuthenticated() {
    return this.getToken() !== null;
  }

   static getAuthentication() {
    return { 'Authorization': 'Bearer ' + this.getToken() }
  }

   static getNewToken() {
    return axios.get(`${baseUrl}/user/refreshToken`)
        .then(response => {
          console.log("got new token")
          this.storeToken(response.data.token);
          return response.data.token;
        });
  }

   static storeToken(token) {
    localStorage.setItem(TokenStorage.LOCAL_STORAGE_TOKEN, token);
  }

   static clear() {
    localStorage.removeItem(TokenStorage.LOCAL_STORAGE_TOKEN);
  }

  static getToken() {
    return localStorage.getItem(TokenStorage.LOCAL_STORAGE_TOKEN);
  }
}